import Vue from 'vue'
import Router from 'vue-router'

import auth from '@/store/modules/auth'

const AccountPage           = () => import(/* webpackChunkName: "account"       */ '@/app/account/AccountPage.vue')
const BrandsPage            = () => import(/* webpackChunkName: "brands"        */ '@/app/brands/BrandsPage.vue')
const CategoryDetailsPage   = () => import(/* webpackChunkName: "categories"    */ '@/app/categories/CategoryDetailsPage.vue')
const CouponPage            = () => import(/* webpackChunkName: "coupons"       */ '@/app/coupons/CouponsPage')
const CouponDetailsPage     = () => import(/* webpackChunkName: "coupons"       */ '@/app/coupons/CouponDetailsPage')
const ExportPage            = () => import(/* webpackChunkName: "export"        */ '@/app/export/ExportPage')
const HouseholdPage         = () => import(/* webpackChunkName: "household"     */ '@/app/household/HouseholdPage.vue')
const PantryItemDetailsPage = () => import(/* webpackChunkName: "pantry"        */ '@/app/pantry/PantryItemDetailsPage.vue')
const PantryPage            = () => import(/* webpackChunkName: "pantry"        */ '@/app/pantry/PantryPage.vue')
const ShoppingListPage      = () => import(/* webpackChunkName: "shopping-list" */ '@/app/shopping-list/ShoppingListPage')
const SignInPage            = () => import(/* webpackChunkName: "sign-in"       */ '@/app/sign-in/SignInPage')
const SignOutPage           = () => import(/* webpackChunkName: "sign-out"      */ '@/app/sign-out/SignOutPage')

Vue.use(Router)

const router = new Router({
	routes: [
		{
			component: AccountPage,
			meta: {
				requiresAuth: true,
			},
			path: '/account',
		},
		{
			component: BrandsPage,
			path: '/brands',
		},
		{
			component: CategoryDetailsPage,
			path: '/category/:id',
		},
		{
			component: CouponPage,
			path: '/coupons',
		},
		{
			component: CouponDetailsPage,
			name: 'coupon',
			path: '/coupon/:id',
		},
		{
			component: ExportPage,
			path: '/export',
		},
		{
			component: HouseholdPage,
			path: '/household',
		},
		{
			component: PantryItemDetailsPage,
			path: '/item/:id',
		},
		{
			component: PantryPage,
			meta: {
				requiresAuth: true,
			},
			name: 'pantry',
			path: '/pantry/:id',
		},
		{
			component: ShoppingListPage,
			path: '/shopping',
		},
		{
			component: SignOutPage,
			path: '/sign-out',
		},
		{
			component: SignInPage,
			path: '/',
		},
		{
			path: '*',
			redirect: '/',
		},
	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	},
})

router.beforeEach((to, from, next) => {
	if (to.meta.requiresAuth) {
		if (!auth.isLoggedIn) {
			return next('/')
		}
	}
	return next()
})

export default router
